import { render, staticRenderFns } from "./StatementInq.vue?vue&type=template&id=1a319194"
import script from "./StatementInq.vue?vue&type=script&lang=js"
export * from "./StatementInq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a319194')) {
      api.createRecord('1a319194', component.options)
    } else {
      api.reload('1a319194', component.options)
    }
    module.hot.accept("./StatementInq.vue?vue&type=template&id=1a319194", function () {
      api.rerender('1a319194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/accounts/StatementInq.vue"
export default component.exports